import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=d7137412&scoped=true"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=d7137412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7137412",
  null
  
)

export default component.exports